<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [heroVideo]="heroVideo"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <!-- Page Title Section -->
  <div class="page-title-section">
    <h2>Assurance Prévoyance Entreprise</h2>
  </div>

  <!-- Main Content -->
  <div class="main-content">
    <p>
      Si vous êtes à la recherche de ce type d'<span class="text-purple">assurance Prévoyance Entreprise</span>, merci de prendre contact avec nous car il existe beaucoup trop de déclinaisons selon votre situation personnelle.
    </p>
  </div>

  <!-- Contact Button -->
  <div class="contact-button-wrapper">
    <button class="btn-contact" (click)="navigateToContact()">
      Contactez-nous
    </button>
  </div>

</app-page-layout>
